import React, { FC } from 'react'

import { TeamLogoProps } from '../../TeamLogo.types'

import { StyledIconTeamLogo } from './IconTeamLogo.style'

export const IconTeamLogo: FC<TeamLogoProps> = ({ logoUrl, isPlace }) => (
  <StyledIconTeamLogo alt="Team Logo" isPlace={isPlace} src={logoUrl} />
)
